import { DashboardQueryKeys, queryClient } from '../shared/api';

/**
 * By default exact is false in react query.
 * Thus it matches the query keys which partially match as well.
 */
export const refetchDashboardKPIs = () => {
  queryClient.refetchQueries({
    queryKey: [DashboardQueryKeys.ProductionKpiQueryKey],
  });
  queryClient.refetchQueries({
    queryKey: [DashboardQueryKeys.PlanningKpiQueryKey],
  });
  queryClient.refetchQueries({
    queryKey: [DashboardQueryKeys.SafetyIndexQueryKey],
  });
  queryClient.refetchQueries({
    queryKey: [DashboardQueryKeys.StockVolumeQueryKey],
  });
};
